








































































































































































import { editFactory } from '@/main/pages';

import CreateModal from '../../servis/zakazka/components/CreateModal.vue';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		CreateModal,
	},
});
